export enum DialogType {
  Confirmation,
  Delete,
}
